<template>
    <div class="container-fluid" style="margin-left: 10px; margin-right: 10px;">
        <div class="card">
            <TankHeader :tank="tank" v-if="loaded"/>
        </div>
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center p-3">
                <h5 class="m-0 text-dark">Histórico de Registro de Volume</h5>
                <VolumeFilter :dates="dates" :type="type" @changeType="setType"/>
            </div>
            <div class="card-body">
                <div v-if="loaded" class="">
                    <apexchart ref="chart" class="apex-charts" height="320" dir="ltr" :series="graphic.series"
                               :options="graphic.chartOptions" @markerClick="clickHandler"/>
                    <VolumeCards :cards="cards" :type="type" :calcRate="calcRate"/>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center" style="height: 320px;">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Carregando...</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn btn-danger" @click="$router.go(-1)">Voltar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted} from "vue";
import {useRoute} from "vue-router";
import TankHeader from "@/components/TelemetryDetail/TankHeader.vue";
import VolumeFilter from "@/components/TelemetryDetail/VolumeFilter.vue";
import VolumeCards from "@/components/TelemetryDetail/VolumeCards.vue";
import {getChartOptions} from "@/components/TelemetryDetail/utils/chartUtils";
import env from "../../env.js";
import {floatToDecimal} from "@/components/Telemetry/Dependencies/functions";

export default {
    components: {TankHeader, VolumeFilter, VolumeCards},
    setup() {
        const route = useRoute();
        const chart = ref(null);
        const loaded = ref(false);
        const dates = ref(false);
        const type = ref(1); // Sempre inicia com "24 horas"
        const tank = ref({});
        const makers = ref([]);
        const cards = ref([]);
        const color = ref(null);
        const graphic = ref({series: [], chartOptions: {}});
        const token = ref(localStorage.getItem('token'));

        // Função para fazer a requisição e obter os logs
        const getLogsApi = async (token, start, end) => {
            try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow"
                };
                const tankId = route.params.id; // Obtém o número do final da URL
                const url = type.value == 4 ? `${env.api}tanques/logs?tankId=${tankId}&tankType=${type.value}&start=${start}&end=${end}`
                    : `${env.api}tanques/logs?tankId=${tankId}&tankType=${type.value}&start=0&end=0`;
                const resultado = await fetch(url, requestOptions)
                    .then((response) => response.json())
                    .catch((error) => {

                    });
                return resultado;
            } catch (e) {
                return;
            }
        };

        // Função para formatar os dados da API para o gráfico
        const formatDataForChart = (logs) => logs.map(item => ({x: item[0], y: item[1]}));

        // Função assíncrona para buscar os logs e atualizar o estado
        const getLogs = async () => {
            try {
                const queryParams = {id: route.params.id, type: type.value};
                if (type.value === 4) {
                    // Para filtro personalizado
                }
                const response = type.value === 4 ? await getLogsApi(token.value, document.getElementById("startFilter").value, document.getElementById("endFilter").value) :
                    await getLogsApi(token.value, '', '');
                if (!response || !response.message || !response.message.tank) return;

                tank.value = response.message.tank;
                const data = formatDataForChart(response.message.logs);
                color.value =
                    tank.value.level > 0
                        ? tank.value.level === 1
                            ? "#3CD188"
                            : tank.value.level === 2
                                ? "#EFAE4E"
                                : "#F7666E"
                        : "#0AC7FB";
                graphic.value = getChartOptions(
                    data,
                    color.value,
                    tank.value.unit,
                    tank.value.capacity,
                    type.value
                );
                loaded.value = true;
            } catch (error) {
                console.log(error);
            }
        };

        const clickHandler = (event, chartContext, config) => {
            const clickedIndex = config.dataPointIndex;
            if (cards.value.length > 1) {
                makers.value = [];
                cards.value = [];
            }
            makers.value.push({
                seriesIndex: 0,
                dataPointIndex: clickedIndex,
                fillColor: color.value,
                strokeColor: color.value,
                size: 8,
            });
            cards.value.push(config.w.config.series[0].data[clickedIndex]);
            cards.value.sort((a, b) => new Date(a.x) - new Date(b.x));
            chart.value.updateOptions({
                markers: {discrete: [...makers.value]}
            }, false, false);
        };

        const calcRate = () => {
            if (cards.value.length < 2) return '';
            let diff = cards.value[0][1] - cards.value[1][1]
            if (diff < 0) diff = diff * (-1);
            const start = new Date(cards.value[0][0])
            const end = new Date(cards.value[1][0])
            let hours = (start - end) / (1000 * 60 * 60);
            if (hours < 0) hours = hours * (-1);
            return `${floatToDecimal(diff / hours)} m³`;
        };

        const setType = (filter) => {
            loaded.value = false;
            type.value = filter.type;

            if (filter.type === 4) {
                // Filtro personalizado
                const start = filter.start;
                const end = filter.end;
                console.log(`Filtro personalizado: De ${start} até ${end}`);
            }

            getLogs();
        };

        onMounted(getLogs);

        return {chart, loaded, dates, type, tank, graphic, cards, calcRate, clickHandler, setType};
    }
};
</script>

<style scoped>
.apex-charts {
    width: 100%;
}

.text-dark {
    color: #2d3748;
}
</style>
